const EIRCODE_PATTERN = /\b(?:(a(4[125s]|6[37]|7[5s]|[8b][1-6s]|9[12468b])|c1[5s]|d([0o][1-9sb]|1[0-8osb]|2[024o]|6w)|e(2[15s]|3[24]|4[15s]|[5s]3|91)|f(12|2[368b]|3[15s]|4[25s]|[5s][26]|9[1-4])|h(1[2468b]|23|[5s][34]|6[25s]|[79]1)|k(3[246]|4[5s]|[5s]6|67|7[8b])|n(3[79]|[49]1)|p(1[247]|2[45s]|3[126]|4[37]|[5s][16]|6[17]|7[25s]|[8b][15s])|r(14|21|3[25s]|4[25s]|[5s][16]|9[35s])|t(12|23|34|4[5s]|[5s]6)|v(1[45s]|23|3[15s]|42|9[2-5s])|w(12|23|34|91)|x(3[5s]|42|91)|y(14|2[15s]|3[45s]))\s?[abcdefhknoprtsvwxy\d]{4})\b/i;
const validation = {
    eircodePattern: 'Unfortunately this eircode is invalid',
};
const EIR_PREQUAL_CONST = {
    url: { recommendedBundle: '/store/api/prequal/recommended-bundles' ,
    getPrequal : '/store/api/prequal/get/' }
};
const TOOLTIP_TEXT_FIRST_PARA = 'Your broadband number is your unique broadband service number which starts with 8881, 8882 or 8883 which will show on your bill.';
const TOOLTIP_TEXT_SECOND_PARA =  'If you do not have a broadband number, please enter your existing home phone number.';
const VALIDATION_TEXT = {
    eircodeValidation: 'Please enter a valid Eircode.',
    phoneNumberValidation: 'Please enter a valid phone number.',
    eircodeRequired: 'Please enter your eircode.',
};

const USE_EIRCODE_TEXT = {
    text: 'Can\'t find your address?',
    //urlText: 'Use your landline number instead',
};

const USE_PHONENUMBER_TEXT = {
    text: 'Use my',
    urlText: 'Eircode instead',
};

const changeAddress = 'Change address »';
const ChangePhonenumber = 'Change phone number »';

const checkAvailabilityText = 'Check availability';

const EIRCODE_TEXTFIELD_ICON_IMAGE =
    '/opencms/export/sites/default/.galleries/eir/prequal/TextFieldIcon.svg';
const PHONENUMBER_TEXTFIELD_TOOLTIPICON_IMAGE =
    '/opencms/export/sites/default/.galleries/eir/prequal/TextFieldIcon2.png';
const SPEEDLINE_PATTERN = /^([0-9]{1,4})([A-Z]{1,2})_.*$/;
const PREQUAL_BY_EIRCODE_FAILED = {
    title: 'Sorry, we can\'t find this eircode',
    textPrefix: 'We have checked ',
    textSuffix: ' Please enter your broadband or phone number to check availability.',
    backgroundImage: '',
    foregroundImageMobile: '',
    foregroundImageDesktop: '',
};
const recommendedBundlesPrefixUrl = '/store/api/prequal/recommended-bundles/';
const customiseBundlesURL = '/customise-bundles/';
const orderSummaryURL = '/checkout/order-summary/';

const PREQUAL_BYPHONE_FAILED_TEXT_1 = 'We have checked';
const PREQUAL_BYPHONE_FAILED_TEXT_2 = 'Not your number?';
const PREQUAL_BYPHONE_FAILED_TEXT_3 = 'Start again »';

export {
    EIRCODE_PATTERN,
    validation,
    EIR_PREQUAL_CONST,
    VALIDATION_TEXT,
    USE_EIRCODE_TEXT,
    USE_PHONENUMBER_TEXT,
    changeAddress,
    ChangePhonenumber,
    checkAvailabilityText,
    EIRCODE_TEXTFIELD_ICON_IMAGE,
    PHONENUMBER_TEXTFIELD_TOOLTIPICON_IMAGE,
    SPEEDLINE_PATTERN,
    PREQUAL_BY_EIRCODE_FAILED,
    recommendedBundlesPrefixUrl,
    customiseBundlesURL,
    orderSummaryURL,
    TOOLTIP_TEXT_FIRST_PARA,
    TOOLTIP_TEXT_SECOND_PARA,
    PREQUAL_BYPHONE_FAILED_TEXT_1,
    PREQUAL_BYPHONE_FAILED_TEXT_2,
    PREQUAL_BYPHONE_FAILED_TEXT_3,

};
